import React, { useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";


const ListCategories = () => {
  const [showData, setData] = useState([]);

  const [queryValue, setQueryValue] = useState('');
  let [selectedItem, setSelectedItem] = useState(0);
  const { register, handleSubmit } = useForm();
  const [backup, setBackup] = useState([]);
  const selectAll = useRef(null);

  const data = [
    {
      id: 1,
      category: 'Beverage',
      brand: 'Bosundara',
      availableProduct: 5000,
    },
    {
      id: 2,
      category: 'shirt',
      brand: 'All Time',
      availableProduct: 5000,
    },
    {
      id: 3,
      category: 'T-Shirt',
      brand: 'Pran',
      availableProduct: 5000,
    },
    {
      id: 4,
      category: 'Jeans',
      brand: 'RFL',
      availableProduct: 5000,
    },
    {
      id: 5,
      category: 'Beverage',
      brand: 'Bosundara',
      availableProduct: 5000,
    },
    {
      id: 6,
      category: 'Sun Glass',
      brand: 'Walton',
      availableProduct: 5000,
    }
  ]
  
  useEffect(() => {
    // fetch("https://jsonplaceholder.typicode.com/users")
    // .then((res) => res.json())
    // .then((data) => setData(data));

    setData(data);
    setBackup(data);
  }, []);
  
  const deleteHandler = ({categoryIds}) => {
    console.log(categoryIds);
    const newCategory = backup.filter(item => !categoryIds.includes(item?.id?.toString() || ''));
    setQueryValue('');
    setData(newCategory);
    selectAll.current.indeterminate = false;
    selectAll.current.checked = false;
    setSelectedItem(0);
  }

  const checkUncheckHandler = (e) => {
    const { id, checked } = e.target;

    if(id === 'allSelect'){
      let x = 0;
      let tempData = showData.filter((user)=> user.category.toLowerCase().includes(queryValue)).map(item => {
        if(checked){
          setSelectedItem(++x);
        }else{
          setSelectedItem(0);
        }
        return {...item, isChecked: checked};
      });
      const restData = backup.filter((user)=> !user.category.toLowerCase().includes(queryValue));
      setData([...tempData, ...restData]);
    }else{
        if(checked){
            selectAll.current.checked = true;
            selectAll.current.indeterminate = true;
            setSelectedItem((prev) => {
                if(prev === (showData.length - 1)){
                    selectAll.current.indeterminate = false;
                    selectAll.current.checked = true;
                };
                return prev+1;
            });
        }else{
            setSelectedItem((prev) => {
                if(prev > 1) selectAll.current.indeterminate = true;
                
                if(prev === 1) selectAll.current.indeterminate = false;
                if((prev-1) === 0) selectAll.current.checked = false;
                
                return prev-1;
            });
        };
        
        let tempCategory = showData.map(item => item.id === parseInt(id) ? {...item, isChecked: checked} : item);
        setData(tempCategory);
    }
  };

  return (
      <div className='container mx-auto px-5 mt-10'>
        {/* action bar */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-y-4 sm:gap-y-0">
          <div>
            <div class="form-control sm:w-72">
              <label class="input-group input-group-sm">
                <span className="pl-2 pr-0 bg-transparent border-2 border-r-0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                </span>
                <input type="text" onChange={(e) => setQueryValue(e.target.value)} placeholder="Search by category name" class="input input-bordered border-l-0 input-sm w-full" />
              </label>
            </div>
          </div>
          <label for="my-modal-3" class="btn btn-sm btn-accent text-white modal-button">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
            </svg>  
            Category
          </label>
        </div>
        <h1 className="text-xl font-semibold text-gray-700 mb-4">Category <span className="text-3xl text-[#e74c3c]">List!</span></h1>
        <>
          {
              selectedItem > 0 &&
              <div className="flex justify-between items-center mb-1 sm:pt-0 sm:gap-4">
                  <p className="text-sm">{selectedItem} selected</p>
                  <button type="submit" className="btn btn-sm btn-square bg-gray-100 border-gray-300 text-black hover:bg-gray-200 hover:border-gray-400" form="categoryListForm">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                  </button>
              </div>
          }
        </>

        <form id="categoryListForm" className="overflow-x-auto" onSubmit={handleSubmit(deleteHandler)}>
          <table className="table table-compact w-full">
            <thead>
              <tr>
                <th>
                  <label>
                    <input type="checkbox" id='allSelect' value={undefined} {...register("categoryIds")} onChange={checkUncheckHandler} className="checkbox" ref={selectAll} />
                  </label>
                </th>
                <th>Category Name</th>
                <th>Available Brand</th>
                <th>Available Product</th>
              </tr>
            </thead>
            <tbody>
              {
              showData.filter((user)=> user.category.toLowerCase().includes(queryValue))
              .map((SingleData) => (
                <tr key={SingleData.id}>
                  <th>
                    <label>
                    <input type="checkbox" id={SingleData.id} value={SingleData.id} {...register("categoryIds")} checked={SingleData?.isChecked || false} onChange={checkUncheckHandler} className="checkbox" />
                    </label>
                  </th>
                  <td>{SingleData.category}</td>
                  <td>{SingleData.brand}</td>
                  <td>{SingleData.availableProduct}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </form>

        {/* modal */}
        <input type="checkbox" id="my-modal-3" class="modal-toggle" />
        <div class="modal">
          <div class="modal-box relative">
            <label for="my-modal-3" class="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
            <h3 class="text-lg font-bold text-center pb-3">Create New Category</h3>
            <form>
              <div class="form-control w-full">
                <label class="label text-sm font-medium">Category name</label>
                <input type="text" placeholder="category name" class="input input-sm input-bordered w-full" />
              </div>
              <button type="submit" className="btn btn-sm w-full btn-accent text-white mt-4">Save</button>
            </form>
          </div>
        </div>
      </div>
  );
};

export default ListCategories;
